<template>
  <v-container ref="pdfContent" fluid fill-height grid-list-md style="padding:0px 10px 5px 10px;width:100%;height:100%;background-color:white;">
    <v-layout row>
      <v-flex d-flex md6>
        <v-layout column>
          <v-flex d-flex md3 style="max-height:25%;">
            <v-layout row>
              <v-flex d-flex md4>
                <Card v-bind:cardData="cardData['pcomp']" v-bind:flat="false"/>
              </v-flex>
              <v-flex d-flex md4>
                <Card v-bind:cardData="cardData['pmax']" v-bind:flat="false"/>
              </v-flex>
              <v-flex d-flex md4>
                <Card v-bind:cardData="cardData['pmaxPcomp']" v-bind:flat="false"/>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md3 style="max-height:25%;">
            <BarChart v-if="chartData['pcomp']" v-bind:active="active" v-bind:chartOptions="chartData['pcomp']" v-bind:title="titles['pcomp']"/>
          </v-flex>
          <v-flex d-flex md3 style="max-height:25%;">
            <BarChart v-if="chartData['pmax']" v-bind:active="active" v-bind:chartOptions="chartData['pmax']" v-bind:title="titles['pmax']"/>
          </v-flex>
          <v-flex d-flex md3 style="max-height:25%;">
            <BarChart v-if="chartData['tExhC']" v-bind:active="active" v-bind:chartOptions="chartData['tExhC']" v-bind:title="titles['tExhC']"/>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex md6>
        <v-layout column>
          <v-flex d-flex md3 style="max-height:25%;">
            <v-layout row>
              <v-flex d-flex md4>
                <Card v-bind:cardData="cardData['tcspeed']" v-bind:flat="false"/>
              </v-flex>
              <v-flex d-flex md4>
                <Card v-bind:cardData="cardData['pscav']" v-bind:flat="false"/>
              </v-flex>
              <v-flex d-flex md4>
                <Card v-bind:cardData="cardData['tscav']" v-bind:flat="false"/>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md3 style="max-height:25%;">
            <v-layout row>
              <v-flex d-flex md4>
                <Card v-bind:cardData="cardData['tTurbIn']" v-bind:flat="false"/>
              </v-flex>
              <v-flex d-flex md4>
                <Card v-bind:cardData="cardData['tTurbO']" v-bind:flat="false"/>
              </v-flex>
              <v-flex d-flex md4>
                <Card v-bind:cardData="cardData['tliner']" v-bind:flat="false"/>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md6 style="max-height:50%;">
            <v-layout row style="height:100%;margin:0px;">
              <v-flex d-flex md4 style="padding:0px;">
                <v-layout column style="height:100%;margin:0px;">
                  <v-flex d-flex md6 style="padding-top: 0; padding-left: 0;">
                    <Card v-bind:cardData="cardData['fRailPres']" v-bind:flat="false"/>
                  </v-flex>
                  <v-flex d-flex md6 style="padding-bottom: 0; padding-left: 0;">
                    <Card v-bind:cardData="cardData['soPresDispl']" v-bind:flat="false"/>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex d-flex md8 style="padding-top: 0; padding-bottom: 0;">
                <LoadDiagram v-if="active" v-bind:active="active" v-bind:chartData="loadDiagram"/>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>

import Card from '../controls/Card'
import BarChart from '../controls/BarChart'
import LoadDiagram from '../controls/LoadDiagram'

import {globalStore} from "../main.js"

export default {
  name: 'EngineParameters',
  components: {
    Card,
    BarChart,
    LoadDiagram
  },
  props: {
    active: Boolean
  },
  data() {
    return {
      cardData: {},
      chartData: {},
      titles: {},
      loadDiagram: {}
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    average: function (param, count, data, timestamp) {
      let sum = 0;

      for (let i = 1; i <= count; i++) {
        if (typeof data[timestamp] != 'undefined' && data[timestamp][param + i] != -1000)
          sum += data[timestamp][param + i];
        else
          count--;
      }

      if (sum == 0 || count == 0)
        return -1000;
      else
        return sum / count;
    },
    setData() {
      let refLength = globalStore.reference.timestamps.length,
          sigLength = globalStore.signals.timestamps.length;

      var temp;

      if (refLength > sigLength)
        temp = globalStore.signals.timestamps;
      else
        temp = globalStore.reference.timestamps;

      let timestamp = ((refLength > sigLength) ? globalStore.signals['lastDate'] : globalStore.reference['lastDate']),
          params = ['pcomp', 'pmax', 'pmaxPcomp', 'tcspeed', 'tscav', 'tTurbO', 'tTurbIn', 'pscav', 'soPresDispl', 'fRailPres'],
          refs = ['pcomp', 'pmax', 'pmaxPcomp', 'tcspeed', 'tscav', 'tTurbO', 'tTurbIn', 'pscav', 'soPresSetpoint', 'fRailPresSet'],
          elCount = [this.cylCount, this.cylCount, this.cylCount, this.tcCount, 0, this.tcCount, this.tcCount, 0, 0, 0];

      var mapping = globalStore.mapping[globalStore.selectedIMO],
          units = globalStore.units[globalStore.selectedIMO],
          limits = globalStore.limits[globalStore.selectedIMO];

      if (typeof mapping == 'undefined') {
        mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
      }

      if (typeof units == 'undefined') {
        units = globalStore.units[Object.keys(globalStore.units)[0]]
      }

      if (typeof limits == 'undefined') {
        limits = globalStore.limits[Object.keys(globalStore.limits)[0]]
      }

      for (let p = 0; p < params.length; p++) {
        let val, rfr;

        if (elCount[p] > 0)
          val = this.average(params[p], elCount[p], globalStore.signals, timestamp);
        else
          val = globalStore.signals[timestamp][params[p]];

        if (params[p] == 'fRailPres')
          rfr = globalStore.signals[timestamp][refs[p]];
        else if (typeof globalStore.reference[timestamp] == 'undefined' || params[p] == 'soPresDispl')
          rfr = -1000;
        else if (elCount[p] > 0) {
          // if (params[p] == 'tTurbO') {
          //   console.log(refs[p], elCount[p], globalStore.reference, timestamp)
          // }

          rfr = this.average(refs[p], elCount[p], globalStore.reference, timestamp);
        }else
          rfr = globalStore.reference[timestamp][refs[p]];

        let color = -10;

        if (isNaN(val))
          val = -1000;

        if (isNaN(rfr))
          rfr = -1000;

        if (val != -1000 && rfr != -1000 && Object.keys(limits).includes(params[p])) {
          let minLimit = limits[params[p]][0], maxLimit = limits[params[p]][1];

          if ((minLimit != null) && (maxLimit != null)) {
            let temp = ((val - rfr) / val) * 100;

            if (temp > minLimit && temp < maxLimit)
              color = 0;
            else
              color = 20;
          }
        }

        // if (params[p] == 'tTurbO') {
        //   console.log(elCount[p])
        //   console.log(rfr)
        // }

        this.$set(this.cardData, params[p], {
          value: val,
          ref: rfr,
          title: mapping['mapping'][params[p]],
          unit: units[params[p]],
          format: 2,
          color: color
        });
      }

      let tlinerParams = [];
      let paramsToCheck = ['tlinerfore', 'tlineraft', 'tlinerA', 'tlinerB', 'tlinerC'];

      paramsToCheck.forEach(param=>{
        let firstVal = globalStore.signals[timestamp][param+1];
        let secVal = globalStore.signals[timestamp][param+1];

        if (!isNaN(firstVal)&&!isNaN(secVal)&&(firstVal>=0)&&secVal>=0)
          tlinerParams.push(param)
      })

      let sum = 0;
      
      tlinerParams.forEach(param=> sum+= this.average(param, this.cylCount, globalStore.signals, timestamp))

      let tlinerVal = sum/tlinerParams.length;
      // let aft = this.average('tlineraft', this.cylCount, globalStore.signals, timestamp),
      //     fore = this.average('tlinerfore', this.cylCount, globalStore.signals, timestamp),
      //     tlinerVal = (aft + fore) / 2;
      
      if (isNaN(tlinerVal))
        tlinerVal = -1000;

      this.$set(this.cardData, 'tliner', {
        value: tlinerVal,
        title: 'Liner Wall Temperature',
        unit: 'deg C',
        format: 2,
        color: -10
      });

      this.chartData = {};

      let chartParams = ['pmax', 'pcomp', 'tExhC'],
          chartRefs = ['pmax', 'pcomp', 'tExhC'];

      for (let p = 0; p < chartParams.length; p++) {
        this.$set(this.chartData, chartParams[p], {
          credits: {enabled: false},
          chart: {
            height: 0,
            zoomType: 'xy'
          },
          legend: {
            enabled: false
          },
          tooltip: {
            formatter: function () {
              if (this.point.ref != -1000)
                return 'Cylinder ' + this.x + ': ' + this.point.y.toFixed(2) + '<br>Reference : ' + this.point.ref.toFixed(2);
              else
                return 'Cylinder ' + this.x + ': ' + this.point.y.toFixed(2) + '<br>Reference : -';
            }
          },
          xAxis: {
            title: {
              text: 'Cylinders',
              align: 'high'
            },
            crosshair: true,
            labels: {
              step: 1
            },
            tickInterval: 1
          },
          yAxis: {
            title: {
              text: '[' + units[chartParams[p]] + ']',
              align: 'high'
            }
          },
          exporting: {
            enabled: false
          },
          title: {
            text: undefined
          },
          series: [
            {
              type: 'column',
              animation: false,
              data: [],
              states: {
                hover: {
                  enabled: false
                },
                normal: {
                  animation: false
                },
                inactive: {
                  opacity: 1
                }
              }
            }
          ]
        });

        for (let i = 1; i <= this.cylCount; i++) {
          let color = 'rgb(51,82, 128)',
              val = ((typeof globalStore.signals[timestamp] != 'undefined') ? globalStore.signals[timestamp][chartParams[p] + i] : -1000),
              rfr = ((typeof globalStore.reference[timestamp] != 'undefined') ? globalStore.reference[timestamp][chartRefs[p] + i] : -1000);

          if (val != -1000 && rfr != -1000 && Object.keys(limits).includes(chartParams[p])) {
            let minLimit = limits[chartParams[p]][0],
                maxLimit = limits[chartParams[p]][1],
                temp = ((val - rfr) / val) * 100;

            if (temp > minLimit && temp < maxLimit)
              color = 'rgb(60, 171, 48)';
            else
              color = 'rgb(255, 184, 29)';
          } else if (val == -1000)
            val = null;

          this.chartData[chartParams[p]].series[0].data.push({
            x: i,
            y: val,
            ref: rfr,
            color: color
          });

          this.$set(this.titles, chartParams[p], mapping['mapping'][chartParams[p]]);
        }
      }

      this.setLoadDiagram();

      globalStore.loading = false;
    },
    setLoadDiagram() {
      this.loadDiagram = {
        credits: {enabled: false},
        chart: {
          height: 0,
          zoomType: 'xy'
        },
        legend: {
          enabled: true
        },
        tooltip: {
          formatter: function () {
            if (this.points)
              return this.points.reduce(function (s, point) {
                return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(0);
              }, '<b>' + this.x.toFixed(1) + ' rpm</b>');
            else if (this.point) {
              if (this.point.ts) {
                let dt = new Date(this.point.ts);

                return '<b>' + this.x.toFixed(1) + ' rpm</b><br/>' + this.point.series.name + ': ' + this.point.y.toFixed(0)
                    + '<br/> at ' + dt.toISOString().substring(0, 16).replace('T', ' ');
              } else return '<b>' + this.x.toFixed(1) + ' rpm</b><br/>' + this.point.series.name + ': ' + this.point.y.toFixed(0) + ' ';
            }
          },
          shared: true
        },
        title: {
          text: undefined
        },
        xAxis: {
          title: {
            text: 'Engine speed [rpm]',
            align: 'high'
          },
          crosshair: true
        },
        yAxis: {
          title: {
            text: 'Shaft power [kW]',
            align: 'high'
          }
        },
        exporting: {
          enabled: false
        },
        series: [
          {
            name: 'Measured',
            type: 'scatter',
            data: [],
            animation: false,
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            },
            marker: {
              radius: 3
            }
          },
          {
            name: 'Reference',
            type: 'scatter',
            data: [],
            animation: false,
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            },
            marker: {
              radius: 3
            }
          },
          {
            name: 'Shop Tests',
            type: 'spline',
            data: [],
            animation: false,
            marker: {
              enabled: false
            },
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          },
          {
            name: 'Sea Trials',
            type: 'line',
            data: [],
            animation: false,
            marker: {
              enabled: false
            },
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          },
          {
            name: 'Engine Limit',
            type: 'line',
            data: [],
            animation: false,
            marker: {
              enabled: false
            },
            states: {
              hover: {
                enabled: false
              },
              normal: {
                animation: false
              },
              inactive: {
                opacity: 1
              }
            }
          }
        ]
      };

      let mcr = globalStore.loadDiagram['otVal1'], timestamp = globalStore.signals['lastDate'];

      this.loadDiagram.series[0].data = [];
      this.loadDiagram.series[1].data = [];

      if (globalStore.type == 'last') {
        let ensp = globalStore.signals[timestamp]['ensp'];

        if ((ensp != -1000) && (ensp != 0)) {
          if (typeof globalStore.signals[timestamp]['shaftP'] != 'undefined' && globalStore.signals[timestamp]['shaftP'] >= 0)
            this.loadDiagram.series[0].data.push({x: ensp, y: globalStore.signals[timestamp]['shaftP']});
          else if (typeof globalStore.signals[timestamp]['ME_Power_kW'] != 'undefined' && globalStore.signals[timestamp]['ME_Power_kW'] >= 0)
            this.loadDiagram.series[0].data.push({x: ensp, y: globalStore.signals[timestamp]['ME_Power_kW']});
          else if (typeof globalStore.signals[timestamp]['load'] != 'undefined' && globalStore.signals[timestamp]['load'] >= 0)
            this.loadDiagram.series[0].data.push({x: ensp, y: globalStore.signals[timestamp]['load'] * mcr});
          // else
          //     this.loadDiagram.series[0].data.push({x:ensp, y: 0});

          if (typeof globalStore.reference[timestamp]['shaftP'] != 'undefined' && globalStore.reference[timestamp]['shaftP'] >= 0)
            this.loadDiagram.series[1].data.push({x: ensp, y: globalStore.reference[timestamp]['shaftP']});
          else if (typeof globalStore.reference[timestamp]['ME_Power_kW'] != 'undefined' && globalStore.reference[timestamp]['ME_Power_kW'] >= 0)
            this.loadDiagram.series[1].data.push({x: ensp, y: globalStore.reference[timestamp]['ME_Power_kW']});
          else if (typeof globalStore.reference[timestamp]['load'] != 'undefined' && globalStore.reference[timestamp]['load'] >= 0)
            this.loadDiagram.series[1].data.push({x: ensp, y: globalStore.reference[timestamp]['load'] * mcr});
          // else
          //     this.loadDiagram.series[1].data.push({x:ensp, y: 0});
        }

      } else
        for (let i = 0; i < globalStore.signals.timestamps.length; i++) {
          let ts = globalStore.signals.timestamps[i];

          let ensp = globalStore.signals[ts]['ensp'];

          if ((ensp != -1000) && (ensp != 0)) {
            if (typeof globalStore.signals[ts]['shaftP'] != 'undefined' && globalStore.signals[ts]['shaftP'] >= 0)
              this.loadDiagram.series[0].data.push({x: ensp, y: globalStore.signals[ts]['shaftP'], ts: ts});
            else if (typeof globalStore.signals[ts]['ME_Power_kW'] != 'undefined' && globalStore.signals[ts]['ME_Power_kW'] >= 0)
              this.loadDiagram.series[0].data.push({x: ensp, y: globalStore.signals[ts]['ME_Power_kW'], ts: ts});
            else if (typeof globalStore.signals[ts]['load'] != 'undefined' && globalStore.signals[ts]['load'] >= 0)
              this.loadDiagram.series[0].data.push({x: ensp, y: globalStore.signals[ts]['load'] * mcr, ts: ts});
            // else
            //     this.loadDiagram.series[0].data.push({x:ensp, y: 0, ts:ts});

            if (typeof globalStore.reference[ts]['shaftP'] != 'undefined' && globalStore.reference[ts]['shaftP'] >= 0)
              this.loadDiagram.series[1].data.push({x: ensp, y: globalStore.reference[ts]['shaftP'], ts: ts});
            else if (typeof globalStore.reference[ts]['ME_Power_kW'] != 'undefined' && globalStore.reference[ts]['ME_Power_kW'] >= 0)
              this.loadDiagram.series[1].data.push({x: ensp, y: globalStore.reference[ts]['ME_Power_kW'], ts: ts});
            else if (typeof globalStore.reference[ts]['load'] != 'undefined' && globalStore.reference[ts]['load'] >= 0)
              this.loadDiagram.series[1].data.push({x: ensp, y: globalStore.reference[ts]['load'] * mcr, ts: ts});
            // else
            //     this.loadDiagram.series[1].data.push({x:ensp, y: 0, ts:ts});
          }
        }

      this.loadDiagram.series[2].data = [];
      for (let i = 0; i < globalStore.loadDiagram.spVal1.length; i++) {
        this.loadDiagram.series[2].data.push([globalStore.loadDiagram['spVal1'][i], globalStore.loadDiagram['spVal7'][i]])
      }

      this.loadDiagram.series[3].data = [];

      for (let i = 0; i < globalStore.loadDiagram.stVal1.length; i++) {
        this.loadDiagram.series[3].data.push([globalStore.loadDiagram['stVal1'][i], globalStore.loadDiagram['stVal2'][i]])
      }

      this.loadDiagram.series[4].data = [];

      let rpmMin = globalStore.loadDiagram['otVal3'],
          rpmMcr = globalStore.loadDiagram['otVal2'],
          mcr97 = globalStore.loadDiagram['otVal4'],
          rpm105 = globalStore.loadDiagram['otVal5'],
          RPMStep = 5.0,
          load = globalStore.signals[timestamp]['load'] * 100;

      this.loadDiagram.series[4].data.push([rpmMin, 0]);

      let aPWR,
          aRPM = rpmMin;

      do {
        aPWR = mcr97 * Math.pow((aRPM / (0.97 * rpmMcr)), 2.0);
        this.loadDiagram.series[4].data.push([aRPM, aPWR]);
        aRPM = aRPM + RPMStep;
      } while (aRPM <= 0.97 * rpmMcr);

      this.loadDiagram.series[4].data.push([0.97 * rpmMcr, mcr97]);
      this.loadDiagram.series[4].data.push([rpmMcr, mcr]);
      this.loadDiagram.series[4].data.push([rpm105, mcr]);
      this.loadDiagram.series[4].data.push([rpm105, 0]);
    }
  },
  computed: {
    dataLoaded: function () {
      return globalStore.type;
    },
    cylCount: function () {
      return globalStore.cylCount;
    },
    tcCount: function () {
      return globalStore.tcCount;
    }
  },
  watch: {
    dataLoaded: function () {
      if (this.dataLoaded != '')
        this.setData();
    }
  }
}
</script>

<style scoped>

</style>
